import { BaseModel } from '@/api/base-model'
import { User } from '@/api/model/user'
import { Branch } from '@/api/model/branch'
import { OrderAPI } from '@/api/backend-client'
import { OrderStatus, OrderType } from '@/api/types'
import { Referral } from '@/api/model/referral'


export class OrderValueShare {
    constructor(
        public id: string,
        public branch: Branch|null,
        public user: User|null,
        public orderValue: number,
        public createdAt: Date,
        public updatedAt: Date,
    ) {}

    static fromData(data: any): OrderValueShare {
        if (data === null || typeof data === 'string' || data instanceof OrderValueShare) {
            return data
        }

        return new OrderValueShare(
            data.id,
            data.branch ? Branch.fromData(data.branch) : null,
            data.user ? User.fromData(data.user) : null,
            data.orderValue,
            data.createdAt,
            data.updatedAt,
        )
    }
}

export class Order extends BaseModel<Order> {
    protected collectionName = OrderAPI.collectionName

    constructor(
        public referral: Referral,
        public id: string,
        public type: OrderType,
        public assignedToBranch: Branch|null,
        public assignedTo: User|null,
        public status: OrderStatus,
        public transactionDate: Date|null,
        public transactionValue: number|null,
        public askingPrice: number|null,
        public orderValue: number|null,
        public involvedUsers: User[],
        public orderValueShares: OrderValueShare[],
        public productionDate: Date|null,
        public createdAt: Date,
        public updatedAt: Date,
    ) {
        super(id)
    }

    static fromData(data: any): Order {
        if (data === null || typeof data === 'string' || data instanceof Order) {
            return data
        }

        return new Order(
            data.referral ? Referral.fromData(data.referral) : null,
            data.id,
            data.type,
            data.assignedToBranch ? Branch.fromData(data.assignedToBranch) : null,
            data.assignedTo ? User.fromData(data.assignedTo) : null,
            data.status,
            data.transactionDate,
            data.transactionValue || 0,
            data.askingPrice || 0,
            data.orderValue || 0,
            Object.values(data.involvedUsers || {}).map(entry => User.fromData(entry)),
            Object.values(data.orderValueShares || {}).map(entry => OrderValueShare.fromData(entry)),
            data.productionDate,
            data.createdAt,
            data.updatedAt,
        )
    }
}
